import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

function mapStateToProps (state) {
  const activeTask = state.myActiveTask.activeTask
  return {
    isActive: activeTask && activeTask.changeRequestId > 0
  }
}

@connect(mapStateToProps)
class ActiveChangeRequest extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isActive: PropTypes.number
  }

  state = {
    creating: false
  }

  render () {
    const { children, isActive } = this.props

    if (isActive) {
      return React.Children.only(children)
    }
    return null
  }
}

export {
  ActiveChangeRequest
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/activeChangeRequest.js